/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_venn_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online Venn diagram maker. Paste one column of items per set to draw a 2- or 3-set Venn diagram with the count in every region calculated automatically.`)
};

const es_venn_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creador gratuito de diagramas de Venn en línea. Pega una columna de elementos por conjunto para dibujar un diagrama de Venn de 2 o 3 conjuntos con el recuento en cada región calculado automáticamente.`)
};

const de_venn_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Venn-Diagramm-Generator. Füge eine Spalte mit Elementen pro Menge ein, um ein Venn-Diagramm mit 2 oder 3 Mengen zu zeichnen, wobei die Anzahl in jeder Region automatisch berechnet wird.`)
};

const nl_venn_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online Venn-diagram maker. Plak één kolom items per set om een Venn-diagram met 2 of 3 sets te tekenen waarbij het aantal in elke regio automatisch wordt berekend.`)
};

const fr_venn_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créateur de diagramme de Venn gratuit en ligne. Collez une colonne d'éléments par ensemble pour tracer un diagramme de Venn à 2 ou 3 ensembles avec le décompte de chaque région calculé automatiquement.`)
};

const it_venn_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creatore gratuito di diagrammi di Venn online. Incolla una colonna di elementi per insieme per disegnare un diagramma di Venn a 2 o 3 insiemi con il conteggio calcolato automaticamente in ogni regione.`)
};

const pt_br2_venn_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador gratuito de diagrama de Venn online. Cole uma coluna de itens por conjunto para desenhar um diagrama de Venn de 2 ou 3 conjuntos com a contagem em cada região calculada automaticamente.`)
};

const pt_venn_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador gratuito de diagramas de Venn online. Cole uma coluna de itens por conjunto para desenhar um diagrama de Venn de 2 ou 3 conjuntos com a contagem calculada automaticamente em cada região.`)
};

const ja_venn_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料オンラインベン図作成ツール。集合ごとに項目を1列貼り付けるだけで、各領域の件数を自動計算した2集合または3集合のベン図を描画します。`)
};

const zh_venn_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费在线维恩图生成器。每组粘贴一列项目，即可绘制 2 组或 3 组维恩图，并自动计算每个区域的数量。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const venn_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.venn_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("venn_meta_description", locale)
	if (locale === "en") return en_venn_meta_description(inputs)
	if (locale === "es") return es_venn_meta_description(inputs)
	if (locale === "de") return de_venn_meta_description(inputs)
	if (locale === "nl") return nl_venn_meta_description(inputs)
	if (locale === "fr") return fr_venn_meta_description(inputs)
	if (locale === "it") return it_venn_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_venn_meta_description(inputs)
	if (locale === "pt") return pt_venn_meta_description(inputs)
	if (locale === "ja") return ja_venn_meta_description(inputs)
	return zh_venn_meta_description(inputs)
};